module.exports = __webpack_public_path__ + "img/8.c3295020.png";